// extracted by mini-css-extract-plugin
module.exports = {"tabContentArea":"Tab-Content--tabContentArea--1ZrKg"};